import { MM_PER_INCH } from '@/utils/math/consts';
import { isInches } from '@/utils/params';

export const getLocalizedSize = (value: number, withUnit = true) => {
  if (isInches()) {
    return `${(value / MM_PER_INCH).toFixed(2)}${withUnit ? ' in' : ''}`;
  }
  return `${value.toFixed(0)}${withUnit ? 'mm' : ''}`;
};
